import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { HlmCheckbox } from '@spartan-ng/helm/checkbox';

/**
 * Field type `checkbox` próprio (substitui o do @ngx-formly/primeng).
 * O label fica ao lado da caixa (por isso o mapper envia hideLabel: true
 * para o wrapper não duplicar o label em cima).
 */
@Component({
  selector: 'evolve-formly-checkbox',
  imports: [ReactiveFormsModule, FormlyModule, HlmCheckbox],
  template: `
    <label class="flex items-center gap-2 cursor-pointer select-none py-2">
      <hlm-checkbox [formControl]="formControl" [formlyAttributes]="field" />
      <span class="text-sm text-foreground">
        {{ props.label }}
        @if (props.required && props['hideRequiredMarker'] !== true) {
          <span class="text-red-500">*</span>
        }
      </span>
    </label>
  `,
})
export class CheckboxFieldComponent extends FieldType<FieldTypeConfig> {}
